import { render, staticRenderFns } from "./comp_Hook-ProductCard-EventIcon.vue?vue&type=template&id=8c4d231c&scoped=true&"
import script from "./comp_Hook-ProductCard-EventIcon.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-ProductCard-EventIcon.vue?vue&type=script&lang=js&"
import style0 from "./comp_Hook-ProductCard-EventIcon.vue?vue&type=style&index=0&id=8c4d231c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4d231c",
  null
  
)

export default component.exports